import {useEffect, useRef, useState} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {RootIcon} from "@ui/icons/RootIcon";
import {useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

const DropdownMenu = (props) => {
  const {head, list, top, children} = props;

  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleClickMenuItem = (link) => {
    navigate(link);
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={styles.dropdown}
      ref={dropdownRef}
    >
      <div
        className={styles.dropdownHeader}
        onClick={toggleDropdown}
      >
        {head}

        <i
          style={
            isOpen ? {transform: "rotate(180deg)"} : {transform: "rotate(0deg)"}
          }
        />
      </div>

      {isOpen && (
        <div
          style={{top: `${top}rem`}}
          className={styles.dropdownList}
        >
          <BorderArticle>
            <ul>
              {list &&
                list.map((item) => (
                  <li
                    key={item.id}
                    onClick={() => handleClickMenuItem(item.link)}
                  >
                    <RootIcon id={item.iconId} />

                    <RootDesc>
                      <span>{item.name}</span>
                    </RootDesc>
                  </li>
                ))}

              {children && <li>{children}</li>}
            </ul>
          </BorderArticle>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
